export function useAuth() {
  const isUserStatusValid = (user = {}) => {
    const validStatus = ['en_attente_dadmissibilite', 'admissible', 'admis']
    const invalidStatus = ['en_prospection', 'validate_email_c', 'demis']
    if (validStatus.includes(user?.user_status)) {
      return true
    } else if (invalidStatus.includes(user?.user_status)) {
      return false
    }
    return false
  }

  const hasUserAccess = (user = {}) => {
    const validStatus = ['admis']
    const invalidStatus = ['en_attente_dadmissibilite', 'admissible', 'en_prospection', 'validate_email_c', 'demis']
    if (validStatus.includes(user?.user_status)) {
      return true
    } else if (invalidStatus.includes(user?.user_status)) {
      return false
    }
    return false
  }

  // Entity-aware status validation (works for user_status, bar_status, firm_status)
  const isEntityStatusValid = (entityStatus) => {
    const validStatus = ['en_attente_dadmissibilite', 'admissible', 'admis']
    const invalidStatus = ['en_prospection', 'validate_email_c', 'demis']
    if (validStatus.includes(entityStatus)) {
      return true
    } else if (invalidStatus.includes(entityStatus)) {
      return false
    }
    return false
  }

  const hasEntityAccess = (entityStatus) => {
    const validStatus = ['admis']
    const invalidStatus = ['en_attente_dadmissibilite', 'admissible', 'en_prospection', 'validate_email_c', 'demis']
    if (validStatus.includes(entityStatus)) {
      return true
    } else if (invalidStatus.includes(entityStatus)) {
      return false
    }
    return false
  }

  // Quality-specific feature access checks
  const canAccessIndividuelFeatures = (entityStatus, userQuality) => {
    return hasEntityAccess(entityStatus) && (userQuality === 'individuel' || !userQuality)
  }

  const canAccessCollectifFeatures = (entityStatus, userQuality) => {
    return hasEntityAccess(entityStatus) && userQuality === 'collectif'
  }

  const canAccessFirmeFeatures = (entityStatus, userQuality) => {
    return hasEntityAccess(entityStatus) && userQuality === 'firme'
  }

  return {
    isUserStatusValid,
    hasUserAccess,
    isEntityStatusValid,
    hasEntityAccess,
    canAccessIndividuelFeatures,
    canAccessCollectifFeatures,
    canAccessFirmeFeatures
  }
}
